<template>
  <ClientOnly>
    <transition name="sf-fade">
      <div v-if="isMobile">
        <slot />
      </div>
    </transition>
  </ClientOnly>
</template>

<script>


export default {
  name: 'ClientMobileOnly',
  setup() {

    const { isMobile } = useUiMode();

    return { isMobile };
  
  },
};

</script>
